import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const Label = styled.label`
  color: ${({ theme }) => theme.colors.formErrorColor};
  display: flex;
  align-items: center;
  font-size: ${({ theme }) => theme.fontSizes[1]}px;
  margin-top: -1rem;
  margin-bottom: 1.5rem;
`

export const Icon = styled(FontAwesomeIcon)`
  font-size: 16px;
  margin-right: 0.5rem;
`
